import axios from "axios";

// const BACKEND_URL = "https://mhs.oauife.edu.ng/api";
const defaultBackendUrl =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api`
    : "http://localhost:5070/api";
const BACKEND_URL = process.env.REACT_APP_API_URL || defaultBackendUrl;

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 30 * 60 * 1000,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    let accessToken = localStorage.getItem("accessToken");

    if (accessToken) config.headers["x-auth-token"] = accessToken;

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
